// @ts-nocheck
(function() {
  const initNewHomeDarkMode = () => {
    const sections = document.querySelectorAll('.new-home-section');

    if (!sections.length) return;

    const transitionImageSource = (image, nextSrc, fadeDuration) => {
      if (!image || !nextSrc) return;

      const currentSrc = image.getAttribute('src');
      if (currentSrc === nextSrc) return;

      // "None" mode: instant synchronous swap, no opacity/transition touch
      if (fadeDuration <= 0) {
        image.style.transition = 'none';
        image.style.opacity = '1';
        image.src = nextSrc;
        image.srcset = nextSrc;
        return;
      }

      const halfDuration = Math.round(fadeDuration / 2);

      image.style.transition = image.style.transition
        ? `${image.style.transition}, opacity ${halfDuration}ms ease`
        : `opacity ${halfDuration}ms ease`;

      const reveal = () => {
        image.style.opacity = '1';
      };

      image.style.opacity = '0';

      window.setTimeout(() => {
        image.src = nextSrc;
        image.srcset = nextSrc;

        if (image.complete) {
          reveal();
        } else {
          image.addEventListener('load', reveal, { once: true });
          image.addEventListener('error', reveal, { once: true });
        }
      }, halfDuration);
    };

    const syncGlobalDarkMode = (isDark, fadeDuration) => {
      document.body.classList.toggle('new-home-dark-mode', isDark);

      const footerGroups = document.querySelectorAll('.footer-utilities__group');
      footerGroups.forEach((group) => {
        group.classList.toggle('new-home-dark-mode', isDark);
      });

      const darkModeTargets = document.querySelectorAll('.header-simple__menu-icon, .shop-all-link');
      darkModeTargets.forEach((target) => {
        target.classList.toggle('new-home-dark-mode', isDark);
      });

      const headerLogos = document.querySelectorAll('.header-simple__logo-image[data-light-src][data-dark-src]');
      headerLogos.forEach((logo) => {
        const nextSrc = isDark ? logo.dataset.darkSrc : logo.dataset.lightSrc;
        if (!nextSrc) return;

        transitionImageSource(logo, nextSrc, fadeDuration);
      });
    };

    sections.forEach((section) => {
      const toggle = section.querySelector('.color-switch');
      if (!toggle) return;

      // Read fade duration from the schema setting (data attribute), default 300ms
      const fadeDuration = parseInt(section.dataset.fadeDuration || '300', 10);

      const initiallyDark = section.classList.contains('is-dark') || toggle.classList.contains('active');
      toggle.classList.toggle('active', initiallyDark);
      syncGlobalDarkMode(initiallyDark, fadeDuration);

      toggle.addEventListener('click', () => {
        const isDark = section.classList.toggle('is-dark');
        toggle.classList.toggle('active', isDark);
        syncGlobalDarkMode(isDark, fadeDuration);

        const shoeImages = section.querySelectorAll('.shoe img[data-light-src][data-dark-src]');
        shoeImages.forEach((image) => {
          const nextSrc = isDark ? image.dataset.darkSrc : image.dataset.lightSrc;
          if (!nextSrc) return;

          transitionImageSource(image, nextSrc, fadeDuration);
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewHomeDarkMode);
  } else {
    initNewHomeDarkMode();
  }
})();
